interface LoadingProps {
  fullScreen?: boolean
  message?: string
}

function Loading({ fullScreen = false, message = 'Loading...' }: LoadingProps) {
  const containerClass = fullScreen
    ? 'fixed inset-0 flex items-center justify-center bg-white z-50'
    : 'flex items-center justify-center p-8'

  return (
    <div className={containerClass}>
      <div className="flex flex-col items-center gap-4">
        <div className="loading-spinner" />
        <p className="text-gray-600">{message}</p>
      </div>
    </div>
  )
}

export default Loading